import React, { Fragment } from 'react';

import CallToAction from './CallToAction';
import { useTranslation } from 'react-i18next';

function PasswordSet() {
  const { t } = useTranslation('translations');

  return (
    <Fragment>
      <header>
        <h1>{t('Password reseted!')}</h1>
      </header>
      <main>
        <p>{t('Your password has been reset successfully. You can now log in using your new password.')}</p>
        <CallToAction action="/login">
          {t('Log In!')}
        </CallToAction>
      </main>
    </Fragment>
  );
}

export default PasswordSet;
